import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import VariableProximity from '../ui/VariableProximity';

const NotFoundPage: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center text-center p-8">
      <div className="section-grain" aria-hidden="true" />
      <div className="glow-card card-backdrop border-2 border-foreground max-w-xl w-full p-10 animate-on-scroll is-visible" ref={containerRef}>
        <div className="font-mono text-xs uppercase tracking-widest text-foreground/60 mb-3">Error Code: 404</div>
        <h1 className="font-display text-5xl font-extrabold leading-tight mb-4">
          <VariableProximity
            label="Packet lost in transit"
            fromFontVariationSettings="'wght' 750, 'ital' 0"
            toFontVariationSettings="'wght' 900, 'ital' 1"
            containerRef={containerRef}
            radius={120}
            falloff="exponential"
            fontFamily="inherit"
          />
        </h1>
        <p className="text-foreground/70 mb-6">We routed you through /dev/null by mistake. The page you’re looking for isn’t here.</p>
        <div className="text-sm text-foreground/60 mb-8">Try turning it off and on again… or go back home.</div>
        <div className="flex items-center justify-center gap-4">
          <Link to="/" className="px-5 py-2 border border-foreground rounded-md hover:bg-primary hover:text-primary-foreground transition-colors">← Back to Home</Link>
          <a href="/#services" className="px-5 py-2 border border-foreground rounded-md hover:bg-primary hover:text-primary-foreground transition-colors">Our Services</a>
        </div>
      </div>
      <div className="mt-6 text-xs font-mono text-foreground/40">If this keeps happening, contact Paokhum.</div>
    </div>
  );
};

export default NotFoundPage;

